export const FIREBASE_COLLECTION_GAMES = "games";
export const FIREBASE_COLLECTION_QUESTIONS = "questions";
export const FIREBASE_COLLECTION_PLAYERS = "players";
export const FIREBASE_COLLECTION_SUBMISSIONS = "submissions";
export const FIREBASE_COLLECTION_SUPERLATIVES = "superlatives";
export const FIREBASE_COLLECTION_NARRATIONS = "narrations";

export const FIREBASE_GAME_FIELD_ROOMID = "roomId";
export const FIREBASE_GAME_FIELD_MANAGERID = "creator";

export const FIREBASE_PLAYER_FIELD_USERID = "userId";

export const FIREBASE_SUBMISSION_FIELD_PLAYER_ID = "playerId";

export const FIREBASE_FUNCTION_CREATE_GAME = "createGameCallable";
export const FIREBASE_FUNCTION_CREATE_GAME_V2 = "createGameV2Callable";
export const FIREBASE_FUNCTION_NAME_COMMIT_QUESTION_SCORES =
  "commitSubmissionScores";
export const FIREBASE_FUNCTION_NAME_CLOSE_QUESTION_SUBMISSIONS =
  "closeQuestionSubmissions";
export const FIREBASE_FUNCTION_NAME_RESET_GAME = "resetGame";
export const FIREBASE_FUNCTION_COPY_GAME = "copyGame";
export const FIREBASE_FUNCTION_DELETE_GAME = "deleteGame";
export const FIREBASE_FUNCTION_NAME_PREPARE_FINAL = "prepareFinalRoundReveal";
export const FIREBASE_FUNCTION_NAME_COMMIT_FINAL_PLAYER_SCORE =
  "commitFinalPlayerScore";
export const FIREBASE_FUNCTION_UPDATE_CATEGORY = "editCategory";
export const FIREBASE_FUNCTION_GENERATE_SUPERLATIVES = "generateSuperlatives";
export const FIREBASE_FUNCTION_GENERATE_NARRATION = "generateNarration";
export const FIREBASE_FUNCTION_GENERATE_AUDIO = "generateAudio";
export const FIREBASE_FUNCTION_GENERATE_CONVERSATIONAL_NARRATION = "generateConversationalNarration";
export const FIREBASE_FUNCTION_GENERATE_ALL_QUESTION_NARRATIONS = "generateAllQuestionNarrations";
export const FIREBASE_FUNCTION_GENERATE_ALL_CATEGORY_AUDIO = "generateAllCategoryAudio";

export const FIREBASE_FUNCTION_CREATE_CUSTOM_TOKEN = "createCustomToken";
export const FIREBASE_FUNCTION_RESET_QUESTION = "resetQuestion";
export const FIREBASE_FUNCTION_SELECT_QUESTION = "selectQuestion";
export const FIREBASE_FUNCTION_CREATE_FINAL_REVEAL_CONVERSATION = "createFinalRevealConversation";
export const FIREBASE_FUNCTION_DEBUG_SET_PRE_FINAL = "debugSetPreFinalCallable";
export const FIREBASE_FUNCTION_SEED_FINAL_TEST_SCENARIO = "seedFinalTestScenarioCallable";

export const EQUALTO = "==";

export const FIREBASE_FUNCTION_SEED_FINALE_SCENARIO = "seedFinaleScenario";
export const FIREBASE_FUNCTION_RETRY_GAME_GENERATION = 'retryGameGenerationCallable';

// Field names inside games/{gameId}.superlatives object
export const SUPERLATIVES_FIELD_STATUS = "superlatives.status";
export const SUPERLATIVES_FIELD_CURRENT_INDEX = "superlatives.currentIndex";
export const SUPERLATIVES_FIELD_FINALE_SHOWN_AT = "superlatives.finaleShownAt";

// Status values
export const SUPERLATIVES_STATUS_GENERATING = "generating";
export const SUPERLATIVES_STATUS_REVEALING = "revealing";
export const SUPERLATIVES_STATUS_FINALE = "finale";
